export default {
  title:
    "Alla Terrazza,<br /> where flavor meets the landscape<br class='hide-for-small' /> and tradition becomes taste.",
  chapter1: {
    title: 'The terrace<br/> of Valdobbiadene',
    text: 'At Alla Terrazza, where flavor meets the landscape and tradition becomes taste, you will find a historic place nestled among the hills of Valdobbiadene. Our osteria has always been a meeting point for those who seek authenticity: a timeless corner where breathtaking views embrace the vineyards and the slow rhythm of nature accompanies every toast. An experience that blends the beauty of the land with the warm hospitality of the past.',
  },
  chapter2: {
    title: 'Wines and cuisine<br/> of the Prosecco hills',
    text: 'At Alla Terrazza, every glass speaks the language of our hills: we serve the finest local wines, from fresh and fragrant Prosecco to the most renowned labels of the territory. The cuisine, genuine and carefully prepared, brings to the table traditional Venetian dishes, made with selected ingredients and recipes that carry the scent of home. A perfect balance between glass and fork, for a journey that celebrates authentic flavors and the joy of conviviality.',
  },
  chapter3: {
    title: 'Between hills and Dolomites',
    text: 'At Alla Terrazza, every gaze drifts across the rows of Prosecco, a UNESCO World Heritage site, toward the horizon that stretches to the Dolomites and Venice. A unique land, filled with enchanting views and an enogastronomic culture that tells centuries of history. Here, between nature and tradition, time seems to slow down, leaving space for the truest emotions: a place deeply rooted in its land, inviting you to discover it, glass after glass.',
  },
  altInterno: 'Interior of Osteria alla Terrazza in Valdobbiadene',
  altOste: 'The host at Osteria alla Terrazza',
  altAperitivo:
    'Aperitivo with Valdobbiadene Prosecco at Osteria alla Terrazza',
  altUova: 'Illustration of hard-boiled eggs, traditional Veneto cuisine',
  altProsecco:
    'View over the UNESCO Prosecco Hills vineyards from Valdobbiadene',
  banner: {
    title: 'After the aperitif, the pleasure continues',
    text: 'End your evening in style: just a few steps from here, Locanda Solagna awaits you with cuisine that celebrates the land and a truly warm welcome.',
    cta: 'Discover the Locanda',
  },
}
